/**
 * soundSync · v2.7.65+E226
 * ────────────────────────
 * Instant cross-tab propagation of system-sound changes. When an admin
 * uploads/resets a tone in the Audio Test Panel we (a) fire the same-tab
 * `rtg:system_sounds_updated` window event AND (b) post on a BroadcastChannel
 * so EVERY other open console in the same browser refreshes its active-sound
 * map immediately — no 30s wait. (The 30s poll in useAudioAlerts remains the
 * cross-DEVICE / other-browser fallback.)
 */
const CHANNEL = "rtg_sound_sync";
let _bc = null;

function chan() {
  if (typeof window === "undefined" || typeof BroadcastChannel === "undefined") return null;
  if (!_bc) {
    try { _bc = new BroadcastChannel(CHANNEL); } catch { _bc = null; }
  }
  return _bc;
}

/** Announce a sound change to this tab + all other tabs in this browser. */
export function broadcastSoundChange(detail = {}) {
  try { window.dispatchEvent(new CustomEvent("rtg:system_sounds_updated", { detail })); } catch { /* noop */ }
  try { chan()?.postMessage({ type: "system_sounds_updated", detail, at: Date.now() }); } catch { /* noop */ }
}

/**
 * Subscribe to sound changes from THIS tab (window event) and OTHER tabs
 * (BroadcastChannel). Returns an unsubscribe fn.
 */
export function subscribeSoundChange(cb) {
  const onWin = (e) => { try { cb(e?.detail || {}); } catch { /* noop */ } };
  window.addEventListener("rtg:system_sounds_updated", onWin);
  const c = chan();
  const onMsg = (ev) => { if (ev?.data?.type === "system_sounds_updated") { try { cb(ev.data.detail || {}); } catch { /* noop */ } } };
  try { c?.addEventListener("message", onMsg); } catch { /* noop */ }
  return () => {
    window.removeEventListener("rtg:system_sounds_updated", onWin);
    try { c?.removeEventListener("message", onMsg); } catch { /* noop */ }
  };
}
